<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.research subject") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content px-0">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
          <!-- Subject ID -->
          <div class="form-group mb-lg-0 w-100 pr-1">
            <label class="mb-0">{{ $t("navigations.subject id") }}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="searchdata.SubjectCode"
              name="subjectid"
            >
              <option value="">{{ $t("navigations.all") }}</option>
              <option
                v-for="subject in dataList"
                :key="subject"
                :value="subject"
              >
                {{ subject }}
              </option>
            </select>
          </div>

          <!-- Milestone -->
          <div class="form-group mb-lg-0 w-100 pr-1">
            <label class="mb-0">{{ $t("navigations.milestone") }}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="searchdata.Milestone"
            >
              <option value="">{{ $t("navigations.all") }}</option>
              <option
                v-for="milestone in milestoneList"
                :key="milestone"
                :value="milestone"
              >
                {{ milestone }}
              </option>
            </select>
          </div>

          <!-- Subject State -->
          <div class="form-group mb-lg-0 w-100 pr-1">
            <label class="mb-0">{{ $t("navigations.subject state") }}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="searchdata.SubjectState"
            >
              <option value="">{{ $t("navigations.all") }}</option>
              <option
                v-for="state in subjectStateList"
                :key="state"
                :value="state"
              >
                {{ state }}
              </option>
            </select>
          </div>

          <!-- Scheduled Date -->
          <div class="form-group mb-lg-0 w-100 pr-1">
            <label class="mb-0">Enrolment Date</label>
            <input
              type="date"
              class="form-control my-md-2 my-lg-0"
              v-model="searchdata.StartDate"
            />
          </div>

          <!-- "to" text -->
          <div
            class="d-flex align-items-end justify-content-center mb-lg-0 px-1"
            style="min-width: 32px"
          >
            <span class="mb-2 mb-lg-1">to</span>
          </div>

          <!-- End Date (no label) -->
          <div class="form-group mb-lg-0 w-100 pr-1">
            <label class="mb-0 invisible">End Date</label>
            <input
              type="date"
              class="form-control my-md-2 my-lg-0"
              v-model="searchdata.EndDate"
            />
          </div>

          <span
            type="button"
            class="w-100 save_btn mx-lg-1 align-self-end"
            @click="SearchButtonClicked()"
          >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5 class="my-0">{{ $t("navigations.research subject") }}</h5>

        <div class="d-flex align-items-center">
          <div class="me-3 d-flex align-items-center">
            <label for="sitecode" class="form-label me-2 mb-0">Site Code</label>
            <select
              id="sitecode"
              v-model="selectedSiteCode"
              class="form-select form-select-sm"
              style="width: auto"
            >
              <option disabled value="">Select Sitecode</option>
              <option
                v-for="code in siteCodes"
                :key="code"
                :value="code.siteID"
              >
                {{ code.siteCode }}
              </option>
            </select>
          </div>
          <button
            class="btn btn-primary btn-sm me-3"
            @click="refreshData"
            :disabled="isRefreshing"
          >
            <span v-if="isRefreshing">
              <i class="spinner-border spinner-border-sm me-2"></i>
              Refreshing...
            </span>
            <span v-else> Refresh Data </span>
          </button>

          <div
            class="position-relative cursor-pointer"
            v-if="subjectList.length != 0"
            @click.prevent="showFilter = !showFilter"
          >
            <img
              src="../../assets/img/filter.png"
              width="17"
              height="17"
              alt="filter table"
            />

            <div class="tool-tip">
              {{ $t("navigations.filter") }}
            </div>
          </div>
        </div>
      </div>

      <div class="ibox-content">
        <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
          <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
            <div
              class="table-multi-select-dropdown"
              @click.stop="dropdownOpen = !dropdownOpen"
            >
              <div class="selected-options">
                <span>{{ $t("navigations.select columns") }}</span>
              </div>
              <div class="dropdown-arrow"></div>
            </div>
            <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
              <label v-for="(column, index) in getColumns" :key="index">
                <input
                  type="checkbox"
                  v-model="selectedcolumnobj[column]"
                  :value="true"
                />
                {{ column }}
              </label>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="showLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
        <div v-else class="table-responsive">
          <div class="text-center" v-if="subjectList.length === 0">
            {{ $t("navigations.no data available") }}
          </div>
          <template v-else>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th
                    v-if="selectedcolumnobj['Subject ID']"
                    class="sort_block"
                    @click="SortSelected('SubjectCode', 1)"
                    id="1"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Subject ID
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th
                    v-if="selectedcolumnobj['Enrollment Date']"
                    class="sort_block"
                    @click="SortSelected('EnrollmentDate', 2)"
                    id="2"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Enrolment Date
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Milestone']"
                    class="sort_block"
                    @click="SortSelected('Milestone', 3)"
                    id="3"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Milestone
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th
                    v-if="selectedcolumnobj['Milestone Date']"
                    class="sort_block"
                    @click="SortSelected('MilestoneDate', 4)"
                    id="4"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Milestone Changed On
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Subject State']"
                    class="sort_block"
                    @click="SortSelected('SubjectState', 5)"
                    id="5"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Subject State
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['State Start Date']"
                    class="sort_block"
                    @click="SortSelected('StateStartDate', 6)"
                    id="6"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      State Changed On
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th
                    v-if="selectedcolumnobj['Last Synced']"
                    class="sort_block"
                    @click="SortSelected('LastSyncedAt', 7)"
                    id="7"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Last Synced
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th
                    v-if="selectedcolumnobj['Last Updated']"
                    class="sort_block"
                    @click="SortSelected('LastUpdatedAt', 8)"
                    id="8"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      Last Updated
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>Status</th>
                  <th>Schedule</th>
                  <th>Sync Data</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in subjectList" :key="item.SubjectId">
                  <td v-if="selectedcolumnobj['Subject ID']">{{ item.SubjectCode }}</td>
                  <td v-if="selectedcolumnobj['Enrollment Date']">{{ formatdatetime(item.EnrollmentDate) }}</td>
                  <td v-if="selectedcolumnobj['Milestone']">{{ item.Milestone }}</td>
                  <td v-if="selectedcolumnobj['Milestone Date']">{{ formatdatetime(item.MilestoneDate) }}</td>
                  <td v-if="selectedcolumnobj['Subject State']">{{ item.State }}</td>
                  <td v-if="selectedcolumnobj['State Start Date']">{{ formatdatetime(item.StateStartDate) }}</td>
                  <td v-if="selectedcolumnobj['Last Synced']">{{ formatdatetime(item.LastSyncedAt) }}</td>
                  <td v-if="selectedcolumnobj['Last Updated']">{{ formatdatetime(item.LastUpdatedAt) }}</td>
                  <td>
                    <span
                      v-if="item.UpdateStatus === 'Updated'"
                      class="badge badge-warning"
                    >
                      Updated
                    </span>
                    <span
                      v-else-if="item.UpdateStatus === 'New'"
                      class="badge badge-success"
                    >
                      New
                    </span>
                    <span v-else class="badge badge-secondary">
                      {{ item.UpdateStatus }}
                    </span>
                  </td>

                  <td class="d-flex justify-content-around">
                    <i
                      class="fa fa-calendar edit-delete"
                      v-if="isscheduled(item.SubjectCode)"
                      @click="gotosubjecttree(item.SubjectId, item.SiteId)"
                    ></i>
                    <button
                        v-if="!isscheduled(item.SubjectCode)"
                        type="button"
                        class="save_btn py-0 px-3"
                        :disabled="creatingScheduleId === item.SubjectId"
                        @click.prevent="postSchedule(item.SubjectId)"
                      >
                        <span v-if="creatingScheduleId !== item.SubjectId">Create</span>
                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                  </td>
                  <td class="text-center sync-cell">
                    <!-- Sync button -->
                    <i
                      class="fa fa-refresh edit-delete"
                      title="Sync Subject Data"
                      :class="{ spin: spinsync[item.SubjectCode] }"
                      @click="syncSubject(item.SubjectCode)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <!------ pagination -------->
          </template>
        </div>
        <div class="row mx-0" v-if="subjectList.length != 0">
          <div class="col-lg-12 mx-0 px-0">
            <div
              class="dataTables_paginate paging_simple_numbers pagination float-right"
            >
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination
                  v-model="currentPage"
                  :pages="totalLists"
                  :range-size="1"
                  active-color="#618bd7"
                  @update:modelValue="loadPage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script src="./ResearchFhirSubject.js" type="text/javascript">
</script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}
.page-links {
  border-radius: 0px;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
.status-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 60px;
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}
.badge-primary {
  color: #fff;
  background-color: #007bff;
}
.img-width {
  width: 14px;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.sync-cell {
  vertical-align: middle;
}
.spin {
  animation: fa-spin 1s linear infinite;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>